<div class="app-container responsive-container">

  <div class="integration-imports-filter-panel">
    <cc-date-filter
      [datePickerOpened]="datePickerOpened"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [startDate]="params.dateFrom"
      [endDate]="params.dateTo"
      [opens]="opens"
      (change)="onDateFilterChange($event)">
    </cc-date-filter>
    <cc-integration-type-filter
      [entries]="operations"
      titleTranslateKey="INTEGRATIONS.FILTERS.TYPE"
      (selectionChange)="onOperationsChanged($event)"
      [label]="'INTEGRATIONS.FILTERS.TYPE' | translate"
    >
    </cc-integration-type-filter>
    <cc-integration-type-filter
      [entries]="statuses"
      titleTranslateKey="INTEGRATIONS.STATUS"
      (selectionChange)="onStatusesChanged($event)"
      [label]="'INTEGRATIONS.FILTERS.STATUS' | translate"
    >
    </cc-integration-type-filter>
    <cc-integration-type-filter
      [entries]="platforms"
      titleTranslateKey="INTEGRATIONS.FILTERS.INTEGRATION"
      (selectionChange)="onPlatformsChanged($event)"
      [label]="'INTEGRATIONS.FILTERS.INTEGRATION' | translate"
    >
    </cc-integration-type-filter>
  </div>


  <cc-box>
    <div class="call-history-list-content" content box>
      <cc-search-filter></cc-search-filter>
      <cc-integration-imports-table
        [dataSource]="dataSource"
        (rejectedClicked)="rejectedClicked($event)"
      >
      </cc-integration-imports-table>
      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [length]="total"
        [pageSize]="paginator.pageSize"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </div>
  </cc-box>
</div>

